import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import { useState } from "react";
import { useForm } from "react-hook-form";

// css
import styles from "../../../layout/Auth/Auth.module.scss";
import ForgetPassword from "../../../components/auth/ForgetPassword";
import ResetPassword from "../../../components/auth/ResetPassword";

const ForgotPassword = () => {
  const [isOtpSended, setIsOtpSended] = useState(false);
  const [email, setEmail] = useState("");

  return (
    <>
      <div className="formInner px-lg-5 px-3 position-relative d-flex align-items-center justify-content-center flex-column h-100">
        <Link
          to="/login"
          className="d-inline-flex align-items-center justify-content-center border py-2 position-absolute broder-light btn "
          style={{ top: 0, left: 0 }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
          >
            <path
              d="M13.1578 2.3669C13.0659 2.27474 12.9567 2.20163 12.8365 2.15174C12.7162 2.10185 12.5873 2.07617 12.4572 2.07617C12.327 2.07617 12.1981 2.10185 12.0779 2.15174C11.9577 2.20163 11.8485 2.27474 11.7566 2.3669L5.17781 8.94565C5.10442 9.01889 5.04619 9.10588 5.00646 9.20165C4.96674 9.29743 4.94629 9.40009 4.94629 9.50377C4.94629 9.60746 4.96674 9.71012 5.00646 9.80589C5.04619 9.90166 5.10442 9.98866 5.17781 10.0619L11.7566 16.6406C12.1445 17.0286 12.7699 17.0286 13.1578 16.6406C13.5457 16.2527 13.5457 15.6273 13.1578 15.2394L7.42614 9.49982L13.1657 3.76023C13.5457 3.38023 13.5457 2.7469 13.1578 2.3669Z"
              fill="#1E232C"
              stroke="#1E232C"
              stroke-width="0.2"
            />
          </svg>
        </Link>
        {isOtpSended ? (
          <ResetPassword email={email} />
        ) : (
          <ForgetPassword setEmail={setEmail} setIsOtpSended={setIsOtpSended} />
        )}
      </div>
    </>
  );
};
export default ForgotPassword;
